import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-publikationen',
  templateUrl: './publikationen.component.html',
  styleUrls: ['./../app.component.css']
})
export class PublikationenComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
